import { Icon, FlexContainer, Spinner, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import Upload from 'Components/icons/Upload';
import File from 'Components/icons/File';
import * as Styled from './styles';
import { ViewProps } from './types';

const View = ({
  loading,
  testID,
  isDragActive,
  isLoaded,
  files,
  label,
  getRootProps,
  getInputProps,
  openBrowser,
  onDeleteFile,
}: ViewProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  return (
    <FlexContainer direction="column" gap="dimension_16">
      {label && (
        <Text type="paragraphs" size="M_M_S" color="dark" align="start">
          {t(label)}
        </Text>
      )}
      {files.length > 0 &&
        files.map(file => (
          <Styled.UploadComponent key={file.name}>
            <Styled.AsideContent>
              {loading ? <Spinner size="S" /> : <File />}
              <Text type="paragraphs" size="S_M_S" color="dark">
                {file.name}
              </Text>

              <Styled.TrashButton
                type="button"
                onClick={() => onDeleteFile(file)}
                testID="deleteFileIcon"
              >
                <Icon color="error" height={24} icon="IconTrash" width={24} />
              </Styled.TrashButton>
            </Styled.AsideContent>
          </Styled.UploadComponent>
        ))}
      {!isLoaded && (
        <Styled.DropZone {...getRootProps()} isDragActive={isDragActive} data-testid={testID}>
          <input data-testid={`${testID}-input`} {...getInputProps()} />
          <Styled.BrowseButton type="button" onClick={openBrowser} data-testid="buttonDrop">
            <FlexContainer align="center" justify="center" gap="dimension_08">
              <Upload />
              <Text type="paragraphs" size="S_M_S" color="dark">
                {t('DG.uploadFile')}
              </Text>
            </FlexContainer>
          </Styled.BrowseButton>
        </Styled.DropZone>
      )}
    </FlexContainer>
  );
};

export default View;
